"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

export const chatSearchToolRegistry = {
  searchChats: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./search-chats").then(({ SearchChatsToolView }) => ({
        default: SearchChatsToolView,
      }))
    ),
  },
  getConversation: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./conversation-recall").then(({ GetConversationToolView }) => ({
        default: GetConversationToolView,
      }))
    ),
  },
  recallToolResult: {
    kind: "step",
    category: "research",
    view: lazy(() =>
      import("./conversation-recall").then(({ RecallToolResultToolView }) => ({
        default: RecallToolResultToolView,
      }))
    ),
  },
} satisfies ToolUIRegistry;
